import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
          内容分类
        </h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
          >
            <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
              <i className={`${cat.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
            </div>
            <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-300">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}